import { render } from "./UpdatePassword.vue?vue&type=template&id=5da8ff52&ts=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__